var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-edit-call-position px-2 px-md-4 py-2 py-md-4"},[_c('AdminCallPositionDetail',{attrs:{"positionId":_vm.$route.params.positionId},on:{"updated":_vm.goBackToList,"deleted":_vm.goBackToList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }